import React from 'react';
import styles from "./course-card-ribbons.module.css";
/**
 * Props for `CourseCardRibbons`
 */

/**
 * Ribbons container for `CourseCard`
 *
 * Generally, include one {@link @udemy/react-messaging-components#Ribbon | `Ribbon`}
 * component as a child component.
 *
 * It will not render anything if there are no `children`.
 */
export const CourseCardRibbons = _ref => {
  let {
    children
  } = _ref;
  return children ? /*#__PURE__*/React.createElement("div", {
    className: styles['course-ribbons']
  }, children) : null;
};
/**
 * @deprecated Use {@link CourseCardRibbons} instead.
 */

export const CourseCardBadges = CourseCardRibbons;
/**
 * @deprecated Use {@link CourseCardRibbonsProps} instead.
 */
//# sourceMappingURL=course-card-ribbons.react-component.js.map